import React from 'react';
import BaseStage from '../BaseStage/BaseStage';
import Button from 'commonComponents/Button/Button';
import HeaderWithLogo from '../HeaderWithLogo/HeaderWithLogo';
import classNames from 'classnames';
import styles from './StageWithText.module.scss';

const StageWithText = ({ title, subtitle, text, logo, button, type, pageName }) => {
  const classes = classNames(
    styles.StageWithText,
    styles[pageName]
  );

  const headersProps = { title, subtitle, logo, type };
  
  return (
    <BaseStage pageName={ pageName }>
      <div className={ classes }>
        <HeaderWithLogo { ...headersProps } />
        <p>{ text }</p>
        { button && ( <p className={ styles.buttonWrapper }>
          <Button { ...button } />
        </p> )
        }
      </div>
    </BaseStage>
  );
};

export default StageWithText;
